import close from '@assets/nuevos-iconos/x.png'
import flechaIco from '@assets/sidebar/Flecha.png'
import { useFetchProyects } from '@hooks/useFetchProyets'
import { getUsuariosTiendas } from '@proxies/getShopsUsers'
import { getTiendas, TiendaApi } from '@proxies/getTiendas'
import * as Select from '@radix-ui/react-select'
import * as Toggle from '@radix-ui/react-toggle'
import { useAppStore } from '@store'
import { Store } from '@types'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ProjectDetails } from './ProjectDetails'
import { ProjectSort } from './ProjectSort'

const SelectItem = React.forwardRef<HTMLDivElement, Select.SelectItemProps>(
  ({ children, ...props }, forwardedRef) => (
    <Select.Item
      {...props}
      ref={forwardedRef}
    >
      <Select.ItemText>{children}</Select.ItemText>
    </Select.Item>
  ),
)
SelectItem.displayName = 'SelectItem'

type UsuariosTiendasResponse = {
  tiendas?: {
    idTiendas: number
    disenadores?: { idUsuarios: number; nombre: string }[]
    usuariosFinales?: { idUsuarios: number; nombre: string }[]
  }[]
}

export function EditProject() {
  const navigate = useNavigate()
  const editProyectHref = '/planner/proyectos'
  const closeModal = useAppStore.use.closeModal()
  const openModal = useAppStore.use.openModal()
  const [texto, setTexto] = useState('')
  const [orden, setOrden] = useState(5)
  const tipoUsuario = useAppStore((s) => s.tipoUsuario)
  const idTiendas = useAppStore((s) => s.idTiendas)
  const disVerUsu = useAppStore((s) => s.disVerUsu)
  const disVerdis = useAppStore((s) => s.disVerdis)
  const isUserFinal = tipoUsuario === 'U'
  const [verMisDisenyos, setVerMisDisenyos] = useState<boolean | null>(true)
  const [verDisenyosCreadoPorMi, setVerDisenyosCreadoPorMi] = useState<boolean | null>(null)
  const [verUFDisenyosVinculadoDis, setVerUFDisenyosVinculadoDis] = useState<boolean | null>(null)
  const [tiendas, setTiendas] = useState<TiendaApi[]>([])
  const [selectedTienda, setSelectedTienda] = useState<string>('')
  const [isTiendaOpen, setIsTiendaOpen] = useState(false)
  const [designers, setDesigners] = useState<{ id: number; nombre: string }[]>([])
  const [selectedDesigner, setSelectedDesigner] = useState<string>('')
  const [isDesignerOpen, setIsDesignerOpen] = useState(false)
  const [users, setUsers] = useState<{ id: number; nombre: string }[]>([])
  const [selectedUser, setSelectedUser] = useState<string>('')
  const [isUserOpen, setIsUserOpen] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const idTiendaParam =
    tipoUsuario === 'G'
      ? selectedTienda && selectedTienda !== 'none'
        ? Number(selectedTienda)
        : undefined
      : idTiendas
        ? Number(idTiendas)
        : undefined

  const idDisenyadorParam =
    selectedDesigner && selectedDesigner !== 'none' ? Number(selectedDesigner) : undefined

  const idUsuarioFinalParam =
    selectedUser && selectedUser !== 'none' ? Number(selectedUser) : undefined

  // const getDisenyosParams = () => {
  //   const paramC = verUFDisenyosVinculadoDis ? false : null

  //   if (tipoUsuario === 'U') {
  //     return { paramA: verMisDisenyos, paramB: true, paramC }
  //   }

  //   if (!verMisDisenyos && !verDisenyosCreadoPorMi) {
  //     return { paramA: null, paramB: null, paramC: paramC }
  //   } else if (verMisDisenyos && !verDisenyosCreadoPorMi) {
  //     return { paramA: true, paramB: null, paramC: paramC }
  //   } else if (verMisDisenyos && verDisenyosCreadoPorMi) {
  //     return { paramA: null, paramB: false, paramC: paramC }
  //   } else if (!verMisDisenyos && verDisenyosCreadoPorMi) {
  //     return { paramA: false, paramB: false, paramC: paramC }
  //   }
  //   return { paramA: null, paramB: null, paramC: paramC }
  // }

  // const disenyosParams = getDisenyosParams()

  // Si tipoUsuario es null, usar 'U' como valor por defecto
  const tipoUsuarioFinal = tipoUsuario || 'U'

  // Para usuarios tipo D, verMisDisenyos siempre debe ser true
  const verMisDisenyosForFetch = tipoUsuarioFinal === 'D' ? true : verMisDisenyos

  // Para usuarios tipo U, cuando verMisDisenyos es true, verDisenyosCreadoPorMi debe ser null (no true)
  // El backend espera verMisDisenyos: true y verDisenyosCreadoPorMi: null para usuarios tipo U
  const verDisenyosCreadoPorMiForFetch =
    tipoUsuarioFinal === 'U' && verMisDisenyosForFetch === true ? null : verDisenyosCreadoPorMi

  // Para usuarios tipo G, si verDisenyosCreadoPorMi es true pero no hay idAsignado disponible,
  // no activar ese filtro (el backend requiere idAsignado cuando verDisenyosCreadoPorMi es true)
  const idUsuariosStr = sessionStorage.getItem('idUsuarios')
  const idAsignado = idUsuariosStr ? Number(idUsuariosStr) : null
  const hasValidIdAsignado = idAsignado !== null && !isNaN(idAsignado) && idAsignado > 0

  // Enviar exactamente como están los toggles, sin transformaciones
  // El backend resolverá si son mutuamente excluyentes o no
  const verDisenyosCreadoPorMiForFetchFinal = verDisenyosCreadoPorMiForFetch
  const verMisDisenyosForFetchFinal = verMisDisenyosForFetch
  const verUFDisenyosVinculadoDisFinal = verUFDisenyosVinculadoDis

  const { proyectsData, refetch } = useFetchProyects(
    orden,
    texto,
    verMisDisenyosForFetchFinal,
    verDisenyosCreadoPorMiForFetchFinal,
    verUFDisenyosVinculadoDisFinal,
    tipoUsuarioFinal,
    idTiendaParam,
    idDisenyadorParam,
    idUsuarioFinalParam,
  )

  useEffect(() => {
    refetch()
  }, [idTiendaParam, idDisenyadorParam, idUsuarioFinalParam])

  const orderOptions = [
    { value: '0', label: 'Nombre' },
    { value: '1', label: 'Apellidos' },
    { value: '2', label: 'Email' },
    { value: '3', label: 'Teléfono' },
    { value: '4', label: 'Fecha de inicio' },
    { value: '5', label: 'Fecha de última modificación' },
    { value: '6', label: 'Estado' },
  ]

  useEffect(() => {
    openModal()
    if (inputRef.current) {
      inputRef.current?.focus()
    }
    return () => {
      closeModal()
    }
  }, [closeModal, openModal])

  useEffect(() => {
    getTiendas().then((tiendasData) => {
      setTiendas(tiendasData)
      if ((tipoUsuario === 'A' || tipoUsuario === 'D') && idTiendas) {
        setSelectedTienda(String(idTiendas))
      }
    })
  }, [tipoUsuario, idTiendas])

  useEffect(() => {
    if (selectedTienda) {
      getUsuariosTiendas('', true).then((data) => {
        const response = data as UsuariosTiendasResponse
        const tienda = response.tiendas?.find((t) => String(t.idTiendas) === selectedTienda)
        setDesigners(
          (tienda?.disenadores ?? []).map((d) => ({ id: d.idUsuarios, nombre: d.nombre })),
        )
        setUsers(
          (tienda?.usuariosFinales ?? []).map((u) => ({ id: u.idUsuarios, nombre: u.nombre })),
        )
        setSelectedDesigner('')
        setSelectedUser('')
      })
    } else {
      setDesigners([])
      setUsers([])
      setSelectedDesigner('')
      setSelectedUser('')
    }
  }, [selectedTienda])

  useEffect(() => {
    if (tipoUsuario === 'U') {
      setVerMisDisenyos(true)
      setVerDisenyosCreadoPorMi(true)
      setVerUFDisenyosVinculadoDis(null)
    } else if (tipoUsuario === 'D') {
      // Para usuarios tipo D, verMisDisenyos siempre debe ser true
      setVerMisDisenyos(true)
    } else if (tipoUsuario === 'G' || tipoUsuario === 'A') {
      // Para usuarios tipo G y A, verMisDisenyos debe estar en true por defecto
      setVerMisDisenyos(true)
    }
  }, [tipoUsuario])

  // Asegurar que verMisDisenyos siempre sea true para usuarios tipo D
  useEffect(() => {
    if (tipoUsuario === 'D' && verMisDisenyos !== true) {
      setVerMisDisenyos(true)
    }
  }, [tipoUsuario, verMisDisenyos])

  // Asegurar que verMisDisenyos esté en true al montar el componente (excepto para tipo D que ya está manejado arriba)
  useEffect(() => {
    if (tipoUsuario !== 'D' && verMisDisenyos === null) {
      setVerMisDisenyos(true)
    }
  }, [])

  // Log selected values for debugging
  // useEffect(() => {
  //   const tiendaObj = tiendas.find((t) => String(t.idTiendas) === selectedTienda)
  //   const designerObj = designers.find((d) => String(d.id) === selectedDesigner)
  //   const userObj = users.find((u) => String(u.id) === selectedUser)
  //   console.log(
  //     'Selected Tienda:',
  //     tiendaObj ? `${tiendaObj.nombre} (id: ${tiendaObj.idTiendas})` : 'Ninguna',
  //   )
  //   console.log(
  //     'Selected Diseñador:',
  //     designerObj ? `${designerObj.nombre} (id: ${designerObj.id})` : 'Ninguno',
  //   )
  //   console.log(
  //     'Selected Usuario Final:',
  //     userObj ? `${userObj.nombre} (id: ${userObj.id})` : 'Ninguno',
  //   )
  // }, [selectedTienda, selectedDesigner, selectedUser, tiendas, designers, users])

  return (
    <div className='white-background edit-project-manager h-100vh w-100vw scrollbar absolute bottom-0 left-0 right-0 top-0 m-auto flex flex-col items-center overflow-x-hidden overflow-y-scroll rounded-[15px]'>
      {typeof tipoUsuario === 'string' && ['G', 'A', 'D'].includes(tipoUsuario ?? '') ? (
        <div className='sticky top-0 z-50 mb-1 flex w-full max-w-[1330px] flex-col border-[1px] border-colorAtemporal bg-C/Color1 p-2'>
          {['A', 'D'].includes(tipoUsuario) && idTiendas && (
            <div className='ml-2 text-base font-semibold text-C/Color5'>
              {tiendas.find((t) => String(t.idTiendas) === String(idTiendas))?.nombre}
            </div>
          )}
          <div
            className='absolute right-4 top-2 z-10 cursor-pointer'
            onClick={() => {
              closeModal()
              if (window.location.pathname.startsWith(editProyectHref)) {
                navigate('/planner')
              } else {
                navigate('/planner')
              }
            }}
          >
            <img
              className='h-3 w-3'
              src={close}
              alt='Cerrar'
            />
          </div>
          <div className=' mt-3 flex w-full flex-row flex-nowrap items-start gap-x-2.5'>
            <div
              className={`flex ${tipoUsuario === 'G' ? 'w-[250px]' : 'w-[300px]'} flex-col justify-start rounded-lg bg-C/Color10 p-1 text-main-gray shadow-md`}
            >
              <label className='mb-0.5 ml-1 text-xs font-semibold text-C/Color5'>
                {'Ordenar por'}
              </label>
              <Select.Root
                value={String(orden)}
                onValueChange={(v) => setOrden(Number(v))}
              >
                <Select.Trigger className='relative h-9 w-full rounded-lg border border-solid border-C/Color4 bg-white pr-8 text-[14px] text-C/Color5'>
                  <Select.Value
                    placeholder={'Fecha de última modificación'}
                    className='overflow-hidden text-ellipsis whitespace-nowrap'
                  />
                  <img
                    src={flechaIco}
                    alt='icon arrow'
                    className='pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 transition-transform duration-200'
                  />
                </Select.Trigger>
                <Select.Portal>
                  <Select.Content
                    position='popper'
                    className={`z-50 ${tipoUsuario === 'G' ? 'w-[241px]' : 'w-[291px]'} rounded-lg border border-solid border-C/Color4 bg-white text-C/Color5`}
                  >
                    <Select.Viewport className=' my-1'>
                      <Select.Group>
                        {orderOptions.map((opt) => (
                          <SelectItem
                            key={opt.value}
                            value={opt.value}
                            className={
                              'w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-2 py-1 transition-colors ' +
                              (String(orden) === opt.value
                                ? ' bg-C/Color3 text-white'
                                : ' hover:bg-C/Color3 hover:text-white')
                            }
                          >
                            {opt.label}
                          </SelectItem>
                        ))}
                      </Select.Group>
                    </Select.Viewport>
                  </Select.Content>
                </Select.Portal>
              </Select.Root>
            </div>

            {tipoUsuario === 'G' && (
              <div className='flex w-[210px] flex-col justify-start rounded-lg bg-C/Color10 p-1 text-main-gray shadow-md'>
                <label className='mb-0.5 ml-1 text-xs font-semibold text-C/Color5'>
                  {'Tienda'}
                </label>
                <Select.Root
                  value={selectedTienda || 'none'}
                  onValueChange={(value) => setSelectedTienda(value === 'none' ? '' : value)}
                  open={isTiendaOpen}
                  onOpenChange={setIsTiendaOpen}
                >
                  <Select.Trigger className='relative h-9 w-full rounded-lg border border-solid border-C/Color4 bg-white pl-2 pr-8 text-[14px] text-C/Color5'>
                    <Select.Value
                      placeholder='Tienda'
                      className='overflow-hidden text-ellipsis whitespace-nowrap'
                    />
                    <img
                      src={flechaIco}
                      alt='icon arrow'
                      className={`pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 transition-transform duration-200 ${isTiendaOpen ? 'rotate-180' : ''}`}
                    />
                  </Select.Trigger>
                  <Select.Portal>
                    <Select.Content
                      position='popper'
                      className='z-50 w-[200px] rounded-lg border border-solid border-C/Color4 bg-white text-C/Color5'
                    >
                      <Select.Viewport className='mt-1'>
                        <Select.Group>
                          <SelectItem
                            value='none'
                            className={
                              'w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-2 py-1 transition-colors ' +
                              (selectedTienda === ''
                                ? ' bg-C/Color3 text-white'
                                : ' hover:bg-C/Color3 hover:text-white')
                            }
                          >
                            {'Ninguna Selección'}
                          </SelectItem>
                          {tiendas.map((tienda) => (
                            <SelectItem
                              value={String(tienda.idTiendas)}
                              key={tienda.idTiendas}
                              className={
                                'w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-2 py-1 transition-colors' +
                                (selectedTienda === String(tienda.idTiendas)
                                  ? ' bg-C/Color3  text-white'
                                  : ' hover:bg-C/Color3 hover:text-white')
                              }
                            >
                              {tienda.nombre}
                            </SelectItem>
                          ))}
                        </Select.Group>
                      </Select.Viewport>
                    </Select.Content>
                  </Select.Portal>
                </Select.Root>
              </div>
            )}
            {(tipoUsuario === 'G' ||
              ((tipoUsuario === 'A' || tipoUsuario === 'D') && disVerdis)) && (
              <div
                className={`flex ${tipoUsuario === 'G' ? 'w-[210px]' : 'w-[300px]'} flex-col justify-start rounded-lg bg-C/Color10 p-1 text-main-gray shadow-md`}
              >
                <label className='mb-0.5 ml-1 text-xs font-semibold text-C/Color5'>
                  {'Diseñador'}
                </label>
                <Select.Root
                  value={selectedDesigner || 'none'}
                  onValueChange={(value) => setSelectedDesigner(value === 'none' ? '' : value)}
                  open={isDesignerOpen}
                  onOpenChange={setIsDesignerOpen}
                  disabled={!selectedTienda}
                >
                  <Select.Trigger className='relative h-9 w-full rounded-lg border border-solid border-C/Color4 bg-white pl-2 pr-8 text-[14px] text-C/Color5'>
                    <Select.Value
                      placeholder='Diseñador'
                      className='overflow-hidden text-ellipsis whitespace-nowrap'
                    />
                    <img
                      src={flechaIco}
                      alt='icon arrow'
                      className={`pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 transition-transform duration-200 ${isDesignerOpen ? 'rotate-180' : ''}`}
                    />
                  </Select.Trigger>
                  <Select.Portal>
                    <Select.Content
                      position='popper'
                      className={`z-50 ${tipoUsuario === 'G' ? 'w-[200px]' : 'w-[290px]'} rounded-lg border border-solid border-C/Color4 bg-white text-C/Color5`}
                    >
                      <Select.Viewport className='mt-1'>
                        <Select.Group>
                          <SelectItem
                            value='none'
                            className={
                              'w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-2 py-1 transition-colors ' +
                              (selectedDesigner === ''
                                ? ' bg-C/Color3 text-white'
                                : ' hover:bg-C/Color3 hover:text-white')
                            }
                          >
                            {'Ninguna Selección'}
                          </SelectItem>
                          {designers.map((designer) => (
                            <SelectItem
                              value={String(designer.id)}
                              key={designer.id}
                              className={
                                'w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-2 py-1 transition-colors ' +
                                (selectedDesigner === String(designer.id)
                                  ? ' bg-C/Color3 text-white'
                                  : ' hover:bg-C/Color3 hover:text-white')
                              }
                            >
                              {designer.nombre}
                            </SelectItem>
                          ))}
                        </Select.Group>
                      </Select.Viewport>
                    </Select.Content>
                  </Select.Portal>
                </Select.Root>
              </div>
            )}
            {(tipoUsuario === 'G' ||
              ((tipoUsuario === 'A' || tipoUsuario === 'D') && disVerUsu)) && (
              <div
                className={`flex ${tipoUsuario === 'G' ? 'w-[270px]' : 'w-[360px]'} flex-col justify-start rounded-lg bg-C/Color10 p-1 text-main-gray shadow-md`}
              >
                <label className='mb-0.5 ml-1 text-xs font-semibold text-C/Color5'>
                  {'Usuario final'}
                </label>
                <Select.Root
                  value={selectedUser || 'none'}
                  onValueChange={(value) => setSelectedUser(value === 'none' ? '' : value)}
                  open={isUserOpen}
                  onOpenChange={setIsUserOpen}
                  disabled={!selectedTienda}
                >
                  <Select.Trigger className='relative h-9 w-full rounded-lg border border-solid border-C/Color4 bg-white pl-2 pr-8 text-[14px] text-C/Color5'>
                    <Select.Value
                      placeholder='Usuario final'
                      className='overflow-hidden text-ellipsis whitespace-nowrap'
                    />
                    <img
                      src={flechaIco}
                      alt='icon arrow'
                      className={`pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 transition-transform duration-200 ${isUserOpen ? 'rotate-180' : ''}`}
                    />
                  </Select.Trigger>
                  <Select.Portal>
                    <Select.Content
                      position='popper'
                      className={`z-50 ${tipoUsuario === 'G' ? 'w-[260px]' : 'w-[350px]'} rounded-lg border border-solid border-C/Color4 bg-white text-C/Color5`}
                    >
                      <Select.Viewport className='mt-1'>
                        <Select.Group>
                          <SelectItem
                            value='none'
                            className={
                              'w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-2 py-1 transition-colors ' +
                              (selectedUser === ''
                                ? ' bg-C/Color3 text-white'
                                : ' hover:bg-C/Color3 hover:text-white')
                            }
                          >
                            {'Ninguna Selección'}
                          </SelectItem>
                          {users.map((user) => (
                            <SelectItem
                              value={String(user.id)}
                              key={user.id}
                              className={
                                'w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap px-2 py-1 transition-colors ' +
                                (selectedUser === String(user.id)
                                  ? ' bg-C/Color3 text-white'
                                  : ' hover:bg-C/Color3 hover:text-white')
                              }
                            >
                              {user.nombre}
                            </SelectItem>
                          ))}
                        </Select.Group>
                      </Select.Viewport>
                    </Select.Content>
                  </Select.Portal>
                </Select.Root>
              </div>
            )}
            <div
              className={`flex ${
                tipoUsuario === 'G'
                  ? 'w-[310px]'
                  : ['A', 'D'].includes(tipoUsuario) && !disVerUsu && !disVerdis
                    ? 'w-[670px]'
                    : ['A', 'D'].includes(tipoUsuario) && (!disVerUsu || !disVerdis)
                      ? 'w-[480px]'
                      : 'w-[300px]'
              } flex-col justify-start rounded-lg bg-C/Color10 p-1 text-main-gray shadow-md`}
              onMouseDown={(e) => {
                // Permitir que los eventos del input funcionen correctamente
                if ((e.target as HTMLElement).tagName === 'INPUT') {
                  e.stopPropagation()
                }
              }}
            >
              <label className='mb-0.5 ml-1 text-xs font-semibold text-C/Color5'>{'Buscar'}</label>
              <input
                ref={inputRef}
                className='proyectSearchInput relative z-10 h-9 w-full rounded border border-C/Color4 bg-white px-3 text-C/Color4 outline-none'
                value={texto}
                onChange={(e) => {
                  e.stopPropagation()
                  const value = e.target.value
                  setTexto(value)
                }}
                onKeyDown={(e) => {
                  e.stopPropagation()
                }}
                onKeyUp={(e) => {
                  e.stopPropagation()
                }}
                onInput={(e) => {
                  e.stopPropagation()
                  const value = (e.target as HTMLInputElement).value
                  setTexto(value)
                }}
                onClick={(e) => {
                  e.stopPropagation()
                }}
                onFocus={(e) => {
                  e.stopPropagation()
                }}
                autoComplete='off'
                type='search'
                aria-label='Buscar proyectos'
                placeholder={'Buscar...'}
              />
            </div>
          </div>
          {!isUserFinal && (
            <div className='ml-1 mt-3 flex flex-row flex-wrap items-center gap-x-8 gap-y-2'>
              <div className='flex items-center text-[14px] text-C/Color5'>
                <Toggle.Root
                  pressed={verMisDisenyos ?? undefined}
                  onPressedChange={tipoUsuario === 'D' ? undefined : setVerMisDisenyos}
                  disabled={tipoUsuario === 'D'}
                  className={`mr-2 h-4 w-8 rounded-full border-2 border-C/Color3 transition-colors duration-200 ${
                    verMisDisenyos ? 'bg-C/Color3' : 'bg-C/Color10'
                  } ${tipoUsuario === 'D' ? 'cursor-not-allowed opacity-50' : ''}`}
                  aria-label='Ver mis diseños'
                >
                  <span
                    className={`block h-3 w-3 rounded-full bg-white shadow transition-transform duration-200 ${verMisDisenyos ? 'translate-x-4' : 'translate-x-1'}`}
                  />
                </Toggle.Root>
                {' Ver mis diseños'}
              </div>
              <div className='flex items-center text-[14px] text-C/Color5'>
                <Toggle.Root
                  pressed={verDisenyosCreadoPorMi ?? undefined}
                  onPressedChange={setVerDisenyosCreadoPorMi}
                  className={`mr-2 h-4 w-8 rounded-full border-2 border-C/Color3 transition-colors duration-200 ${verDisenyosCreadoPorMi ? 'bg-C/Color3' : 'bg-C/Color10'}`}
                  aria-label='Ver diseños creados por mí'
                >
                  <span
                    className={`block h-3 w-3 rounded-full bg-white shadow transition-transform duration-200 ${verDisenyosCreadoPorMi ? 'translate-x-4' : 'translate-x-1'}`}
                  />
                </Toggle.Root>
                {'Ver diseños No creados por mí'}
              </div>
              <div className='flex items-center text-[14px] text-C/Color5'>
                <Toggle.Root
                  pressed={verUFDisenyosVinculadoDis ?? undefined}
                  onPressedChange={setVerUFDisenyosVinculadoDis}
                  className={`mr-2 h-4 w-8 rounded-full border-2 border-C/Color3 transition-colors duration-200 ${verUFDisenyosVinculadoDis ? 'bg-C/Color3' : 'bg-C/Color10'}`}
                  aria-label='Ver UF diseños vinculados'
                >
                  <span
                    className={`block h-3 w-3 rounded-full bg-white shadow transition-transform duration-200 ${verUFDisenyosVinculadoDis ? 'translate-x-4' : 'translate-x-1'}`}
                  />
                </Toggle.Root>
                {'Ver diseños No asignados'}
              </div>
              <div className='flex-1'></div>
              <div className='text-s mr-6 text-right font-bold text-C/Color5'>
                {proyectsData?.length || 0}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className='sticky top-0 z-50 mb-4 flex h-min w-[1330px] flex-col items-start justify-between border-2 border-colorAtemporal bg-C/Color1 px-4 py-2 shadow-m'>
          <div className='ml-2 mt-2 text-base font-semibold text-C/Color5'>
            {'Búsqueda Avanzada'}
          </div>

          <div
            className='absolute right-4 top-4 cursor-pointer'
            onClick={() => {
              closeModal()
              if (window.location.pathname.startsWith(editProyectHref)) {
                navigate('/planner')
              } else {
                navigate('/planner')
              }
            }}
          >
            <img
              className='closeProyectEdit h-3 w-3'
              src={close}
              alt='Cerrar'
            />
          </div>
          <div className='flex w-full flex-row items-center justify-between'>
            <ProjectSort
              isBusinessAccount={true}
              setOrden={setOrden}
              orden={orden}
              texto={texto}
            />
            <span
              className='flex h-9 w-[735px] flex-row-reverse border-none bg-C/Color10 text-main-gray '
              onMouseDown={(e) => {
                // Permitir que los eventos del input funcionen correctamente
                if ((e.target as HTMLElement).tagName === 'INPUT') {
                  e.stopPropagation()
                }
              }}
            >
              <input
                ref={inputRef}
                placeholder={'Buscar...'}
                className='relative z-10 mr-4 h-8 w-[630px] flex-1 border border-C/Color4 bg-white/60 px-2 text-base placeholder-C/Color4'
                value={texto}
                onChange={(e) => {
                  e.stopPropagation()
                  const value = e.target.value
                  setTexto(value)
                }}
                onKeyDown={(e) => {
                  e.stopPropagation()
                }}
                onKeyUp={(e) => {
                  e.stopPropagation()
                }}
                onInput={(e) => {
                  e.stopPropagation()
                  const value = (e.target as HTMLInputElement).value
                  setTexto(value)
                }}
                onClick={(e) => {
                  e.stopPropagation()
                }}
                onFocus={(e) => {
                  e.stopPropagation()
                }}
                autoComplete='off'
                type='search'
                aria-label='Buscar proyectos'
              />
              <div className='mr-2 mt-1 px-2 text-lg text-C/Color5'>{'Buscar'} </div>
            </span>
          </div>
        </div>
      )}
      {proyectsData &&
        proyectsData.map((proyect, index) => (
          <ProjectDetails
            key={`${proyect.disenyo.idDisenos || proyect.disenyo.idVersiones}-${proyect.disenyo.nombreProyecto}-${index}`}
            proyect={proyect}
            refetchProjects={refetch}
          />
        ))}
    </div>
  )
}
